import { Accordion, AccordionButton, AccordionItem, AccordionPanel, Box, Flex, Spacer, Image, Text } from "@chakra-ui/react";
import { ReactElement, useEffect, useState } from "react";
import { FaCheckCircle, FaRegCircle } from "react-icons/fa";

interface ListPaymentProps {
    defaultPaymentMethod: string,
    onChangeCallback: any
}

const ListPayment: React.FC<ListPaymentProps> = ({ defaultPaymentMethod, onChangeCallback }) => {
    const [index, setIndex] = useState<number>(1);

    useEffect(() => {
        if (defaultPaymentMethod === "MIDTRANS") {
            setIndex(0);
        }
        else if (defaultPaymentMethod === "BANKTRANSFER") {
            setIndex(1)
        }
    }, []);

    const onExpand = (expandedIndex: number) => {
        setIndex(expandedIndex);

        if (expandedIndex === 0) {
            onChangeCallback("MIDTRANS");
        }
        else if (expandedIndex === 1) {
            onChangeCallback("BANKTRANSFER")
        }
    };

    return (
        <Accordion variant={"primary"} index={[index]} onChange={onExpand}>
            {/*<AccordionItem>*/}

            {/*    {({ isExpanded }) => (*/}
            {/*        <>*/}
            {/*            <h2>*/}
            {/*                <AccordionButton>*/}
            {/*                    {isExpanded ? (*/}
            {/*                        <FaCheckCircle color={"teal"} fontSize='18px' />*/}
            {/*                    ) : (*/}
            {/*                        <FaRegCircle color={"teal"} fontSize='18px' />*/}
            {/*                    )}*/}
            {/*                    <Flex width={"full"} >*/}
            {/*                        <Box ml={2} textAlign='left' fontWeight={"bold"} fontSize={'sm'}>*/}
            {/*                            Midtrans (Virtual Account & Ewalet)*/}
            {/*                        </Box>*/}
            {/*                        <Spacer />*/}
            {/*                        <Box>*/}
            {/*                            <Image height={'24px'} src="https://res.cloudinary.com/ruang-trader/image/upload/v1662465986/public/payment-method/midtrans_alho9f.svg" />*/}
            {/*                        </Box>*/}
            {/*                    </Flex>*/}
            {/*                </AccordionButton>*/}
            {/*                <AccordionPanel pb={4}>*/}
            {/*                    <Text fontSize={"xs"}>Virtual account</Text>*/}
            {/*                    <Image mt={3} src="https://res.cloudinary.com/ruang-trader/image/upload/v1662551235/public/payment-method/virtual-account_knjmci.png" />*/}
            {/*                </AccordionPanel>*/}
            {/*            </h2>*/}
            {/*        </>*/}
            {/*    )}*/}
            {/*</AccordionItem>*/}

            <AccordionItem>
                <h2>
                    <AccordionButton>
                        <FaCheckCircle color={"teal"} fontSize='18px' />

                        <Flex width={"full"} >
                            <Box ml={2} textAlign='left' fontWeight={"bold"} fontSize={'sm'}>
                                Bank Transfer
                            </Box>
                            <Spacer />
                            <Box>
                                <Image height={'24px'} src="https://res.cloudinary.com/ruang-trader/image/upload/v1662465986/public/payment-method/banktransfer_lvrthy.svg" />
                            </Box>
                        </Flex>
                    </AccordionButton>
                </h2>
            </AccordionItem>
        </Accordion>
    );
};

export default ListPayment;